const instructorFields = [
  {
    name: "user_uuid",
    label: "User Account",
    type: "select",
    placeholder: "Select user account",
    options: [],
  },
  {
    name: "first_name",
    label: "First Name",
    type: "text",
    placeholder: "Type First Name",
  },
  {
    name: "last_name",
    label: "Last Name",
    type: "text",
    placeholder: "Type Last Name",
  },
  {
    name: "age",
    label: "Instructor Age",
    type: "number",
    placeholder: "Type instructor age",
  },
  {
    name: "specialization",
    label: "Instructor Specialization",
    type: "text",
    placeholder: "Type instructor specialization",
  },
  {
    name: "mobile",
    label: "Instructor Mobile",
    type: "phone",
    placeholder: "9xx-xxx-xxxx",
  },
  {
    name: "nationalId",
    label: "National ID",
    type: "text",
    placeholder: "Type 11-digit National ID",
    maxLength: 11,
  },
  {
    name: "certificate",
    label: "Instructor Certificates",
    type: "textarea",
    placeholder: "Type Instructor Certificates",
  },
  {
    name: "present",
    label: "Instructor Present In Platform",
    type: "toggle",
    placeholder: "Select Present",
  },
];

export default instructorFields;
